import { Link } from "react-router-dom";
import { Tent, Loader2 } from "lucide-react";

const shortDay = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "short" });

export const WeekendSlot = ({ weekend, planning, onPlan }) => {
  if (!weekend?.best && !weekend?.driest) return null;
  const { best, driest, options = [] } = weekend;

  return (
    <div className="mt-4 rounded-2xl border border-white/10 bg-page p-3" data-testid="weekend-slot">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-ink-soft">
        <Tent className="h-3.5 w-3.5 text-brand" /> Best weekend slot
      </p>
      {best ? (
        <>
          <p className="mt-1.5 text-sm">
            <span className="font-semibold">{shortDay(best.day)} {best.from} – {best.to}</span>
            {" "}— {best.hours}h under a 30% chance, up to {best.max}°
          </p>
          <button
            data-testid="weekend-plan-best"
            onClick={() => onPlan(best)}
            disabled={Boolean(planning)}
            className="mt-2 inline-flex min-h-[38px] items-center gap-1.5 rounded-full bg-brand px-4 text-xs font-semibold text-white transition-colors hover:bg-brand-hover active:scale-95 disabled:opacity-50"
          >
            {planning === `${best.day}-${best.from}`
              ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Tent className="h-3.5 w-3.5" />}
            Plan it
          </button>
          <div className="mt-2 flex flex-wrap gap-2">
            {options.slice(1).map((o) => (
              <button
                key={`${o.day}-${o.from}`}
                onClick={() => onPlan(o)}
                disabled={Boolean(planning)}
                data-testid={`weekend-option-${o.day}-${o.from}`}
                className="rounded-full border border-white/10 px-3 py-1.5 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-ink disabled:opacity-50"
              >
                {shortDay(o.day)} {o.from}–{o.to} · {o.precip}%
              </button>
            ))}
            <Link
              to={`/calendar?day=${best.day}`}
              data-testid="weekend-open-calendar"
              className="rounded-full px-2 py-1.5 text-xs text-brand underline decoration-dotted"
            >
              Open in calendar
            </Link>
          </div>
        </>
      ) : (
        <p className="mt-1.5 text-sm text-ink-soft" data-testid="weekend-wet">
          No dry window this weekend — {shortDay(driest.day)} is the least wet
          ({driest.precip}%, up to {driest.max}°).
        </p>
      )}
    </div>
  );
};
